__turbopack_context__.v({
  "benefits": "RewardsTierCard-module__23FLpq__benefits",
  "card": "RewardsTierCard-module__23FLpq__card",
  "criteria": "RewardsTierCard-module__23FLpq__criteria",
  "current": "RewardsTierCard-module__23FLpq__current",
  "currentBadge": "RewardsTierCard-module__23FLpq__currentBadge",
  "currentBadgePlaceholder": "RewardsTierCard-module__23FLpq__currentBadgePlaceholder",
  "header": "RewardsTierCard-module__23FLpq__header",
  "name": "RewardsTierCard-module__23FLpq__name",
});
